module.exports = __webpack_public_path__ + "img/Avatar-52.b3dcc788.svg";